import { useEffect, useRef, useState } from 'react';

/**
 * Fires once when an element first scrolls into view.
 *
 * Section entry animations are a single fade-and-rise on first sight and never
 * again — PRD §8. Re-triggering on every scroll past is the thing that makes a
 * page feel restless.
 */
export const useOnScreen = ({ rootMargin = '0px 0px -12% 0px', threshold = 0.05 } = {}) => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || seen) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSeen(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [seen, rootMargin, threshold]);

  return [ref, seen];
};

export default useOnScreen;
